const constants = {
  countryDomain: {
    localhost: 'India',
    'india-nivi-chat-staging.herokuapp.com': 'India',
    'chat.asknivi.in': 'India',
    'nivi-chat-staging.herokuapp.com': 'Kenya',
    'chat.asknivi.ke': 'Kenya',
    'chat.nivi.io': 'Kenya'
  }
};
exports.constants = constants;



// WEBPACK FOOTER //
// ./src/utils/constantHelper.js